import { Injectable } from '@angular/core';
import { Customer } from '../models';
import { saveAs } from 'file-saver';
import { SecuritiesPropertyFilterToReportReturn } from '../models/dtos/securities-property/SecuritiesPropertyFilterToReportReturn';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomerExporterService {
  constructor(private translate: TranslateService) {}

  exportTitlersAndDependents(
    exportList: SecuritiesPropertyFilterToReportReturn[], showDependents: boolean
  ) {

    if (!showDependents) {
      exportList = exportList.filter((item) => { item.tipo==='Titular'  });
    }
    const locale = this.translate.currentLang || 'pt-BR';
    const dateFormatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    import('xlsx').then((xlsx) => {
      const dadosExportacao = exportList.map((register) => ({
        Matrícula: register.numeroId, //gostaria de deixar essa linha em negrito e alinhada a direita
        Nome: register.ownerName,
        Tipo: register.dependentType,
        Nascimento: register.ownerBirthday
          ? dateFormatter.format(new Date(register.ownerBirthday))
          : '',
        Admissão: register.lastAssociation
          ? dateFormatter.format(new Date(register.lastAssociation))
          : '',
        'Tipo de Titulo': register.tipo,
        Bloqueado: register.block? 'Sim' : 'Não',
        'Tipo de Bloqueio':register.block? register.blockType : '',

      }));

      const worksheet = xlsx.utils.json_to_sheet(dadosExportacao);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(
        workbook,
        worksheet,
        'Titulares e Dependentes'
      );

      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const dataAtual = new Date().toISOString().split('T')[0];
      const nomeArquivo = `titulares_dependentes_${dataAtual}.xlsx`;

      saveAs(data, nomeArquivo);
    });

    return exportList;
  }
}
